import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import AddBillingInfoForExistingAccountDto = Cloud.RavenDB.Core.Dto.PaymentInfo.AddBillingInfoForExistingAccountDto;
import InvoiceDetailsDto = Cloud.RavenDB.Core.Dto.Users.InvoiceDetailsDto;
import AddCreditCardDto = Cloud.RavenDB.Core.Dto.PaymentInfo.AddCreditCardDto;
import ChangeActiveCreditCardDto = Cloud.RavenDB.Core.Dto.PaymentInfo.ChangeActiveCreditCardDto;
import RemoveCreditCardDto = Cloud.RavenDB.Core.Dto.PaymentInfo.RemoveCreditCardDto;
import SetCustomInvoiceRecipientEmailDto = Cloud.RavenDB.Core.Dto.PaymentInfo.SetCustomInvoiceRecipientEmailDto;

export default class PaymentInfoService extends AbstractService {
    addBillingInfo = async (domainName: string, dto: AddBillingInfoForExistingAccountDto): Promise<void> => {
        await this.post<AddBillingInfoForExistingAccountDto, void>(
            ApiRoutes.paymentInfo.addBillingInfoForExistingAccount({ domainName }),
            dto
        );
    };

    changeInvoiceDetails = async (domainName: string, dto: InvoiceDetailsDto) => {
        await this.post<InvoiceDetailsDto, void>(ApiRoutes.paymentInfo.changeInvoiceDetails({ domainName }), dto);
    };

    addCreditCard = async (domainName: string, dto: AddCreditCardDto) => {
        await this.post<AddCreditCardDto, void>(ApiRoutes.paymentInfo.addCreditCard({ domainName }), dto);
    };

    changeActiveCreditCard = async (domainName: string, dto: ChangeActiveCreditCardDto) => {
        await this.post<ChangeActiveCreditCardDto, void>(
            ApiRoutes.paymentInfo.changeActiveCreditCard({ domainName }),
            dto
        );
    };

    removeCreditCard = async (domainName: string, dto: RemoveCreditCardDto) => {
        await this.post<RemoveCreditCardDto, void>(ApiRoutes.paymentInfo.removeCreditCard({ domainName }), dto);
    };

    setCustomInvoiceRecipientEmail = async (domainName: string, dto: SetCustomInvoiceRecipientEmailDto) => {
        await this.post<SetCustomInvoiceRecipientEmailDto, void>(
            ApiRoutes.paymentInfo.setCustomInvoiceRecipientEmail({ domainName }),
            dto
        );
    };
}
